import { useState } from "react";
import { faqs } from "@/mocks/gossipData";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="mx-auto max-w-[1360px] scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr]">
        <div>
          <p className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-melon-600">
            Ask &amp; Answer
          </p>
          <h2 className="mt-2 font-heading text-2xl font-black text-ink-950 md:text-3xl">
            瓜友问答
          </h2>
          <p className="mt-3 text-sm leading-7 text-ink-500">
            关于吃瓜推理与分析的常见疑问，我们尽量用「能说清就一次说清」的方式作答。
          </p>
          <div className="mt-6 hidden items-start gap-4 rounded-xl border border-sign-200 bg-sign-100/50 p-5 lg:flex">
            <i className="ri-information-line text-2xl text-sign-600" />
            <p className="text-sm leading-6 text-ink-700">
              还有没解答的疑问？可以订阅早报后随时给我们留言，也可以在我们的社区提问区抛出你的「存疑点」。
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl border bg-paper-50 transition-colors ${
                  open ? "border-sign-300" : "border-ink-800/10"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-start gap-3">
                    <span className="mt-0.5 font-display text-sign-600">Q{i + 1}</span>
                    <span className="font-semibold text-ink-800">{f.q}</span>
                  </span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors ${
                      open ? "border-sign-400 bg-sign-500 text-paper-50" : "border-ink-800/15 text-ink-500"
                    }`}
                  >
                    <i className={`text-base ${open ? "ri-subtract-line" : "ri-add-line"}`} />
                  </span>
                </button>
                {open && (
                  <p className="px-5 pb-5 pl-[58px] text-sm leading-7 text-ink-600 animate-rise">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}